module.exports = __webpack_public_path__ + "static/media/instagram.e3484f2d.svg";